import { Product } from './products';

export interface InventoryStock {
  id: string;
  product_id: string;
  current_quantity: number;
  unit_of_measure: string;
  reorder_level: number;
  last_updated: string;
  created_at: string;
  // Joined
  product?: Product;
}

export interface InventoryTransaction {
  id: string;
  product_id: string;
  transaction_type: 'inbound' | 'outbound' | 'adjustment' | 'damage';
  quantity: number;
  unit_cost: number | null;
  reference_type: 'procurement' | 'sale' | 'manual' | 'damage';
  reference_id: string | null;
  reference_number: string | null;
  notes: string | null;
  created_by: string | null;
  created_at: string;
  // Joined
  product?: Product;
}

export interface DailyStockCount {
  id: string;
  product_id: string;
  count_date: string;
  system_quantity: number;
  physical_quantity: number;
  variance: number;
  variance_reason: string | null;
  counted_by: string | null;
  created_at: string;
  // Joined
  product?: Product;
}

export interface DailyDamage {
  id: string;
  product_id: string;
  damage_date: string;
  quantity: number;
  damage_type: 'expired' | 'spoiled' | 'broken' | 'other';
  damage_value: number | null;  // FIFO-calculated cost of damage
  reason: string | null;
  recorded_by: string | null;
  created_at: string;
  // Joined
  product?: Product;
}

export interface CreateInventoryTransactionInput {
  product_id: string;
  transaction_type: 'inbound' | 'outbound' | 'adjustment' | 'damage';
  quantity: number;
  unit_cost?: number;
  reference_type: 'procurement' | 'sale' | 'manual' | 'damage';
  reference_id?: string;
  reference_number?: string;
  notes?: string;
}

export interface CreateDailyStockCountInput {
  product_id: string;
  count_date: string;
  system_quantity: number;
  physical_quantity: number;
  variance_reason?: string;
}

export interface CreateDailyDamageInput {
  product_id: string;
  damage_date: string;
  quantity: number;
  damage_type: 'expired' | 'spoiled' | 'broken' | 'other';
  reason?: string;
}

export type TransactionType = 'inbound' | 'outbound' | 'adjustment' | 'damage';
export type DamageType = 'expired' | 'spoiled' | 'broken' | 'other';

export const TRANSACTION_TYPE_LABELS: Record<TransactionType, string> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
  adjustment: 'Adjustment',
  damage: 'Damage',
};

export const DAMAGE_TYPE_LABELS: Record<DamageType, string> = {
  expired: 'Expired',
  spoiled: 'Spoiled',
  broken: 'Broken',
  other: 'Other',
};
